import { Component, Vue, Inject } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase';
import appconst from '../../lib/appconst'
import * as moment from 'moment';

@Component
export default class DateTimeMixin extends AbpBase {
    formatDate(date) {
        if(date == undefined || date == null || date == '')
            return '';
        return moment.utc(String(date)).local().format(appconst.datePickerFormatString);
    }

    formatDatetime(date) {
        if(date == undefined || date == null || date == '')
            return '';
        return moment.utc(String(date)).local().format(appconst.viewDateFormat);
    }
    formatTimeDate(date) {
        if(date == undefined || date == null || date == '')
            return '';
        return moment.utc(String(date)).local().format(appconst.viewShortTimeDateFormat);
    }
}